import {createRouter, createWebHistory} from "vue-router";
import store from '../store';
import LoginPage from '@/components/Login.vue';
import DashboardPage from '@/components/Dashboard.vue';
import ContactPage from '@/components/Contact.vue';
import CreateOrderPage from '@/components/Createorder.vue';

const routes = [
    {path: '/', redirect: '/login'},
    {path: '/login', component:LoginPage},
    {path: '/contact', component:ContactPage},
    {path: '/dashboard', component:DashboardPage, meta:{requiresAuth:true}},
    {path: '/createorder', component:CreateOrderPage, meta:{requiresAuth:true}},
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) =>{
    const isLoggedIn = store.state.sessionData.loggedIn;

    if(to.path == '/login' && isLoggedIn){
        next('/dashboard');
        return;
    }

    if(to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn){
        next('/login');
    } else {
        next();
    }

});

export default router;